import React from 'react';
import {
  Box,
  CircularProgress
} from '@mui/material';

const LoadingIndicator = ({ height = '200px' }) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" height={height}>
      <CircularProgress />
    </Box>
  );
};

export default LoadingIndicator; 